import React from "react";
import { FormikProps } from "formik";
import { LoginFormInitialValues } from "./LoginFormWrapper";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPassword from "src/components/UI/atoms/formFields/ATMPassword/ATMPassword";
import { LOGIN_PAGE_NAME } from "src/utils/constants";

type Props = {
  formikProps: FormikProps<LoginFormInitialValues>;
  isInvalidPassword: boolean;
};

const brandName = LOGIN_PAGE_NAME?.trim() || "RCC Lectures";

const LoginForm = ({ formikProps, isInvalidPassword }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="login-page relative min-h-screen overflow-hidden bg-[#fff8ef]">
      <div
        className="pointer-events-none absolute -left-28 -top-24 h-80 w-80 rounded-full bg-[#f6c445]/80"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-24 -right-16 h-72 w-72 rounded-full bg-[#e11d74]/15"
        aria-hidden
      />

      <div className="relative flex min-h-screen items-center justify-center px-4 py-10">
        <div className="login-rise grid w-full max-w-[1120px] overflow-hidden rounded-[28px] bg-white shadow-[0_24px_60px_rgba(12,50,116,0.14)] lg:grid-cols-[420px_1fr]">
          <div className="relative flex flex-col items-center justify-center bg-gradient-to-b from-[#ffe7a3] via-[#fff6df] to-white px-10 py-16">
            <img
              src="/logo192.png"
              alt={brandName}
              className="h-56 w-56 object-contain"
            />
            <p className="mt-3 text-center text-[22px] font-semibold tracking-tight text-[#0c3274]">
              Royal Commerce Classes
            </p>
            <span className="mt-3 h-1 w-16 rounded-full bg-[#e11d74]" />
            <p className="mt-3 text-[13px] font-medium text-[#0c3274]/70">
              Billing console
            </p>
          </div>

          <div className="flex flex-col justify-center px-8 py-14 sm:px-16">
            <h1 className="text-[34px] font-semibold tracking-tight text-slate-900">
              Sign in
            </h1>
            <p className="mt-2 text-[15px] leading-6 text-slate-500">
              Use your billing email to open the console.
            </p>

            <div className="mt-8 flex flex-col gap-6">
              <ATMTextField
                name="email"
                required
                value={values.email}
                onChange={(e) => setFieldValue("email", e.target.value)}
                label="Email"
                placeholder="you@example.com"
                onBlur={handleBlur}
                autoComplete="email"
              />

              <ATMPassword
                name="password"
                required
                value={values.password}
                onChange={(e) => setFieldValue("password", e.target.value)}
                label="Password"
                placeholder="Enter your password"
                onBlur={handleBlur}
                autoComplete="current-password"
                extraClasses={`login-password ${
                  isInvalidPassword ? "shake-horizontal" : ""
                }`}
              />

              <ATMLoadingButton
                isLoading={isSubmitting}
                type="submit"
                className="mt-2 h-12 rounded-xl text-[15px] font-semibold tracking-wide shadow-[0_10px_24px_rgba(12,50,116,0.22)]"
              >
                Login
              </ATMLoadingButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
